module.exports = __webpack_public_path__ + "static/hero-left1-ee7a162fbed8aadc3596ddc682ad2dd1.svg";